export default {
  //  BASE_URL: 'http://localhost:5000/'
//  BASE_URL: 'https://stago.herokuapp.com/'
  BASE_URL: 'https://api.rifird.com/'
}




/** WEBPACK FOOTER **
 ** ./src/constants/BaseConstants.js
 **/